import React from 'react';
import { StatsComponent, StatsProfileTarget } from 'features/stats/StatsComponent';
import './StatsComponent.css';
import { Badge } from 'features/catalog/useBadges';
import './StatsView.css';

interface StatsViewProps {
  onOpenProfile: (profileId: string, target?: StatsProfileTarget) => void;
  setSelectedBadge: (badge: Badge | null) => void;
}

/** Light-shell host for the existing stats dashboard (no legacy background scroller). */
export const StatsView: React.FC<StatsViewProps> = ({ onOpenProfile, setSelectedBadge }) => (
  <div className="stats-view-page">
    <header className="stats-view-header">
      <h1 className="stats-view-title">Badges Stats</h1>
      <p className="stats-view-subtitle">Global rarity, ownership, and journey stats</p>
    </header>
    <StatsComponent onOpenProfile={onOpenProfile} setSelectedBadge={setSelectedBadge} />
  </div>
);
